export function isValidRangeAndNotNull(
  start: number | null | undefined,
  end: number | null | undefined,
  seqLength: number
): boolean {
  if (!(start != null && end != null)) {
    return false;
  }
  return 0 <= start && start < end && end <= seqLength;
}

export function baseInRangeAndNotNull(pos: number | null | undefined, start: number, end: number): boolean {
  if (pos == null) {
    return false;
  }
  return start <= pos && pos < end;
}
